<template>
    <div v-if="authStore.hasUserPermission('warehouse.followupdeliveries.view')" class="card">
      <Panel header="Header" :toggleable="true">
        <template #header>
          <h1 class="m-0">Anleitung (Nachlieferungen/Retouren)</h1>
        </template>
        <div class="reklamation-container">
            <div class="reklamation-section">
        <p class="m-0">
        <h3>Nachlieferung als Abgeschlossen markieren:</h3>
        <p>
            1. Setze den Haken bei "ABG" im Eintrag, den du abschließen möchtest</p>
        </p>
        </div>

            <div class="reklamation-section">
        <p class="m-0">
        <h3>Nachlieferung als <strong>Nicht</strong> abgeschlossen markieren:</h3>
        <p>
            1. Klicke auf den Haken bei "ABG" im Eintrag, den du als nicht mehr Abgeschlossen markieren möchtest</p>
        </p>
        </div>
        <div class="reklamation-section">
        <p class="m-0">
        <h3>Nachlieferung Teilen:</h3>
        <p>
            1. Klicke den Eintrag 2 mal Schnell hintereinander an, um eine Auswahl zu erhalten, als Welche Abteilung du den Eintrag teilen möchtest:
            <br>
            <br><strong>Beispiel:</strong><br>
            <img src="@/assets/contextmenu.png">
            <br>
        </p>
        </p>
        <p style="margin-top:2rem;"></p>
        <p>Nun, kannst du ganz einfach in z.B Microsoft Teams. Rechtsklick -> Einfügen Klicken, und der Eintrag wird als Link eingefügt, und die Person die den Eintrag erhält, kann ihn direkt öffnen.

        </p>
        </div>
        </div>




      </Panel>
    </div>
  </template>
  
  
  <script>
  import { FilterMatchMode } from "primevue/api";
  import axios from "axios";
  import { getAuth } from "firebase/auth";
  import { config } from "@/assets/config.js";
  import { useAuthStore } from "@/stores/auth.js";
  import { useRoute, useRouter } from 'vue-router';
  import Panel from "primevue/panel";
import Button from "primevue/button";
import FloatLabel from "primevue/floatlabel";
import AutoComplete from "primevue/autocomplete";
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import Calendar from 'primevue/calendar';
import Divider from "primevue/divider";
import FileUpload from "primevue/fileupload";
import ContextMenu from "primevue/contextmenu";
  
  export default {
    components: {
      Panel,
      Button,
      FloatLabel,
      AutoComplete,
      InputText,
      Dropdown,
      Calendar,
      Divider,
      FileUpload,
      ContextMenu
    },
  
    data() {
    return {
      authStore: useAuthStore(),
      warehousereclamationsearch: [],
      supplierSuggestions: [],
      articleSuggestions: [],
      createdbySuggestions: [],
      filters: {
        supplier: { value: "", matchMode: FilterMatchMode.CONTAINS },
        order: { value: "", matchMode: FilterMatchMode.CONTAINS },
        incomegoodsnumber: { value: "", matchMode: FilterMatchMode.CONTAINS },
        article: { value: "", matchMode: FilterMatchMode.CONTAINS },
      },
      uploadToken: null,
      loading: true,
      dialogOpen: false,
      size: "small",
      createdby: null,
      date: null,
      configURL: config.api_url,
      supplier: null,
      order: null,
      incomegoodsnumber: null,
      article: null,
      reason: null,
      attachment: null,
      should: null,
      is: null,
      comment: null,
      displayName: null,
      selectedEntry: null,
      completeddate: null,
      reklaausgang: null,
      accounting_action: null,
      showaccounting_actionDropdown: false,
      reklaausgangOptions: [
        "Zurückgeschickt",
        "Outlet",
        "Eingelagert",
        "Nachgeliefert",
        "Ersatzlieferung",
        "Keine Antwort -> Kommentar",
        "Andere... -> Kommentar",
        "Buchhaltung"
      ],
      reasonOptions: [
        "Mengendifferenz",
        "Beschädigt",
        "Nicht geliefert",
        "Falsch geliefert",
        "Qualitätsdifferenz",
        "Backorderüberschreitung",
        "Andere... -> Kommentar",
      ],
      accounting_actionOptions: ["Rechnung", "Gutschrift"],
      contextMenuItems: [],
contextEntry: null,
claimFilterId: null,
    };
  },
  };
  </script>
  
  
  
  <style lang="scss" scoped>
  /* 🔹 Standard Button & Input Styles */
.cua-modal-btn {
  width: 100%;
  height: 2.5rem;
  font-size: 1rem;
  border-radius: 0.5rem;
}
.reklamation-container {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap; /* Optional: allow wrapping on smaller screens */
}

.reklamation-section {
  flex: 1 1 45%;
  min-width: 300px;
}

  </style>
  